import { Accordion } from '@makemydeal/ui-bricks/dist/cox';
import { CustomerInformationCard } from '../CustomerInformationExperience/CustomerInformationCard';
import { StyledAccordionContainer, StyledAccordionSubtitle, StyledAccordionTitle } from './DealSetupScreen.style';
import { useDealSetup } from '../../hooks';
import type { DealSetupCustomerInfoSectionProps } from '../../types';

export const DealSetupCustomerInfoSection: React.FC<DealSetupCustomerInfoSectionProps> = ({
    cardRef,
    onCardSave,
    onCardStateChange,
    expanded,
    onToggle
}) => {
    const { customerName } = useDealSetup();

    // When collapsed, surface the selected customer's name as the accordion subtitle.
    const subtitle =
        !expanded && customerName ? <StyledAccordionSubtitle>Selected : {customerName}</StyledAccordionSubtitle> : undefined;

    return (
        <StyledAccordionContainer>
            <Accordion
                testId="deal-setup-customer-info-accordion"
                justifyContent="space-between"
                useExternalState
                isActive={expanded}
                buttonHandleClick={onToggle}
                title={<StyledAccordionTitle onClick={onToggle}>Customer (required)</StyledAccordionTitle>}
                subtitle={subtitle}
                content={
                    <CustomerInformationCard
                        ref={cardRef}
                        customer="buyer"
                        onSave={onCardSave}
                        onStateChange={onCardStateChange}
                        hideFooter
                        hideLoader
                    />
                }
            />
        </StyledAccordionContainer>
    );
};
